export default __webpack_public_path__ + "static/media/ngo-2.98ceb612.png";